declare const window:any;
namespace ajaxManager{
    /**
     * 请求多个并发ajax 并执行完成回调
     * @param  {any} arr
     * @param  {Function} callBackFunc
     */
    export function moreAjax(arr:any,callBackFunc:Function,failBackFunc?:Function){
        if(Array.isArray(arr)){
            window.axios.all(arr).then(window.axios.spread(function () {
                if(typeof(callBackFunc)=='function'){
                    callBackFunc(arguments);//acct,perms,perms1,perms2,perms3  acct:any,perms:any,perms1:any,perms2:any,perms3:any
                }
            })).catch(function(error:any) {
                if(typeof(failBackFunc)=='function'){
                    callBackFunc(arguments);//acct,perms,perms1,perms2,perms3  acct:any,perms:any,perms1:any,perms2:any,perms3:any
                }else if(typeof(callBackFunc)=='function'){
                    callBackFunc(arguments);
                }
            });;
        }
    }
    export function deleteUndefinedStr(obj: any){
        if(typeof(obj) == "object"){
            if(window.jQuery.isArray(obj)){
                for(let i=0; i<obj.length; i++){
                    if(typeof(obj[i]) == "object"){
                        deleteUndefinedStr(obj[i]);
                    }
                }
            }else{
                for(let key in obj){
                    if(typeof(obj[key]) == "object"){
                        deleteUndefinedStr(obj[key]);
                    }else{
                        if(obj[key] == "undefined"){
                            delete obj[key];
                        }
                    }
                }
            }
        }
    }
    /**
     * 处理ajax入参
     * @param ajaxData 
     */
    export function formatAiaxData(ajaxData:any){
        let data:object = {};
        var newFormData = new FormData();
        if(ajaxData instanceof FormData){
            ajaxData.forEach(function(e,v){
                data[v] = e;
            })
        }else{
            data = ajaxData;
        }
        for (let key in data) {
            switch (data[key]) {
                case '<时间戳>':
                    data[key] = Number(window.moment().format('x'));
                    break;
                case '<时间戳-今天开始>':
                    data[key] = Number(window.moment((window.moment().format('YYYY-MM-DD') + ' 00:00:00')).format('x'));
                    break;
                case '<时间戳-今天结束>':
                    data[key] = Number(window.moment((window.moment().format('YYYY-MM-DD') + ' 23:59:59')).format('x'));
                    break;
                case '<时间戳-昨天开始>':
                    data[key] = Number(window.moment((window.moment().subtract('days', 1).format('YYYY-MM-DD') + ' 00:00:00')).format('x'));
                    break;
                case '<时间戳-昨天结束>':
                    data[key] = Number(window.moment((window.moment().subtract('days', 1).format('YYYY-MM-DD') + ' 23:59:59')).format('x'));
                    break;
                case '<时间戳-本周开始>':
                    let weekOfdayN = parseInt(window.moment().format('d')) // 计算今天是这周第几天 周日为一周中的第一天
                    let start = window.moment().subtract(weekOfdayN - 1, 'days').format('YYYY-MM-DD') // 周一日期
                    data[key] = Number(window.moment((start + ' 00:00:00')).format('x'));
                    break;
                case '<时间戳-本周结束>':
                    let weekOfday = parseInt(window.moment().format('d')) // 计算今天是这周第几天 周日为一周中的第一天
                    let end = window.moment().add(7 - weekOfday, 'days').format('YYYY-MM-DD') // 周日日期
                    data[key] = Number(window.moment((end + ' 23:59:59')).format('x'));
                    break;
                case '<时间戳-本月开始>':
                    let monthDayN = window.moment().add('month', 0).format('YYYY-MM') + '-01';
                    data[key] = Number(window.moment(window.moment(monthDayN).format('YYYY-MM-DD HH:mm:ss')).format('x'));
                    break;
                case '<时间戳-本月结束>':
                    let monthDay = window.moment().add('month', 0).format('YYYY-MM') + '-01';
                    data[key] = Number(window.moment(window.moment(monthDay).add('month', 1).add('days', -1).format('YYYY-MM-DD 23:59:59')).format('x'));
                    break;
                default:
                    data[key] = data[key];
                    break;
            }
            //ajaxDataObj[key] = window.NSUtilsDate.getTimestampByText(ajaxDataObj.data[key]);//发送时间戳参数进行优化处理 20221201
        }
        if(ajaxData instanceof FormData){
           for(let akey in data){
                if(data[akey]){
                    newFormData.append(akey, data[akey])
                }
           }
           data = newFormData;
        }
        return data;
    }
    export function setAjaxConfig(ajaxConfig:any,callBackFunc?:Function,failBackFunc?:Function){
        let authorization = window.NSUtils.OAuthCode.get();
        ajaxConfig.headers = typeof(ajaxConfig.headers)=='object' ? ajaxConfig.headers : {};
        if(authorization == false){
            /*if(typeof(window.NetstarApiConfig.loginUrl) == 'string'){
                const loginUrl = window.NetstarApiConfig.webRootPath + window.NetstarApiConfig.loginUrl;
                window.location = loginUrl;
            }else {
                window.NSUtils.OAuthCode.reLogin();
                return false;
            }*/
        }else{
            ajaxConfig.headers.authorization = authorization;
        }
        if(typeof(window.NetstarMainPage)=='object'){
            if(typeof(window.NetstarMainPage.systemInfo)=='object'){
                if(typeof(window.NetstarMainPage.systemInfo.context)=='object'){
                    if(window.NetstarMainPage.systemInfo.context.envType === 0){
                        let NSDevServerRouter:any = window.store.get('NSDevServerRouter');
                        let NSDevServerState:any = window.store.get('NSDEVSERVERSTATE');//本地联调状态 1开启 0关闭
                        if(typeof(NSDevServerState)!='number'){
                            NSDevServerState = 1;
                            window.store.set('NSDEVSERVERSTATE',1);
                        }
                        if(typeof(NSDevServerRouter)=='string'){
                            if(NSDevServerRouter && NSDevServerState === 1){
                                ajaxConfig.headers['server-router'] = NSDevServerRouter;
                            }
                        }
                    }
                }
            }
        }
        if(ajaxConfig.src){
            ajaxConfig.url = ajaxConfig.src;
        }
        if(ajaxConfig.url.indexOf('http')===-1){
            if(ajaxConfig.isUseGetRootPath === false){
                ajaxConfig.url = window.NSUtils.getUrl({urlType:"web",suffix:ajaxConfig.url});
            }else{
                ajaxConfig.url = window.NSUtils.getUrl({urlType:"api",suffix:ajaxConfig.url}); 
            }
           // ajaxConfig.url = window.NSUtils.getUrl()+ajaxConfig.url;
        }
        if(typeof(window.NetstarHomePage)=='object'){
            if(window.NetstarHomePage.version === 'v4'){
                if (ajaxConfig.url.indexOf('/middleware/') > -1) {
                    let middlewareRootPath = window.NetstarApiConfig.middlewareRootPath;
                    const urlParaObj = window.NSUtils.getUrlPara();
                    if(urlParaObj.nsmidwareserver){
                        middlewareRootPath =  urlParaObj.nsmidwareserver;//如果浏览器指定了地址优先读取浏览器指定的
                    }
                    if(middlewareRootPath.indexOf('middleware/') > -1){
                        middlewareRootPath = middlewareRootPath.replace('middleware/','');
                    }
                    ajaxConfig.url = ajaxConfig.url.replace(window.NSUtils.getUrl() + '/', middlewareRootPath);
                    ajaxConfig.url = ajaxConfig.url.replace(window.NSUtils.getUrl(), middlewareRootPath);
                }
            }
        }
        ajaxConfig.data = typeof(ajaxConfig.data)=='object' ? ajaxConfig.data : {};
        ajaxConfig.proxy = typeof(ajaxConfig.proxy)=='object' ? ajaxConfig.proxy : {};
        ajaxConfig.proxy.callBackFunc = callBackFunc;
        ajaxConfig.proxy.failBackFunc = failBackFunc;
        ajaxConfig.proxy.ajaxAfterHandler = ajaxConfig.ajaxAfterHandler;
        ajaxConfig.proxy.ajaxUrl = ajaxConfig.url;
        if(typeof(ajaxConfig.plusData)=='object'){
            ajaxConfig.proxy.plusData = ajaxConfig.plusData;
        }
        ajaxConfig.contentType = ajaxConfig.contentType ? ajaxConfig.contentType : 'application/json; charset=utf-8';
        if(ajaxConfig.contentType == 'application/json'){
            ajaxConfig.contentType = 'application/json; charset=utf-8';
        }
        let ajaxDataObj:any = {};
        if(window.jQuery.isArray(ajaxConfig.data)){
            ajaxDataObj = ajaxConfig.data;
        }else{
            ajaxDataObj = formatAiaxData(ajaxConfig.data);
        }
        deleteUndefinedStr(ajaxDataObj); // 删除 undefined字符串
        ajaxConfig.data = ajaxDataObj;

        ajaxConfig.method = ajaxConfig.method ? ajaxConfig.method : ajaxConfig.type;
        if(typeof(ajaxConfig.method)=='undefined'){ajaxConfig.method = 'GET';}
        if(ajaxConfig.method.toLocaleLowerCase() == 'get'){
            ajaxConfig.data.Authorization = authorization;
            ajaxConfig.params = ajaxConfig.data;
        }
        if(ajaxConfig.data.Authorization === false){
            delete ajaxConfig.data.Authorization;
        }
        if (ajaxConfig.contentType) {
            ajaxConfig.headers['Content-Type'] = ajaxConfig.contentType;
            if (ajaxConfig.contentType == 'application/json; charset=utf-8') {
                ajaxConfig.data = JSON.stringify(ajaxConfig.data);
            }
        }
        if(ajaxConfig.method.toLocaleLowerCase() == 'post' && ajaxConfig.contentType == 'application/x-www-form-urlencoded'){
            ajaxConfig.transformRequest = [function (data:any){
                // 对 data 进行任意转换处理
                let ret = '';
                for (let it in data) {
                  ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
                }
                ret = ret.substring(0, ret.lastIndexOf('&'));
                return ret;
            }];
        }

        if(ajaxConfig.ajaxBeforeHandler){
            let ajaxBeforeHandler = ajaxConfig.ajaxBeforeHandler;
            if(typeof(ajaxBeforeHandler) == 'string'){
                ajaxBeforeHandler = window.NSUtils.getFunction(ajaxConfig.ajaxBeforeHandler);
            }
            if(typeof(ajaxBeforeHandler) == "function"){
                let _ajaxConfig = ajaxBeforeHandler(ajaxConfig);
                if(_ajaxConfig === false){
                    return false
                }
                if(_ajaxConfig && _ajaxConfig.url){
                    ajaxConfig = _ajaxConfig;
                }
            }
        }
         // 处理url '/netstarApiId{id}'  start --
        let rex = /\/netstarApiId\{(.*?)\}/;
        let urlStr = ajaxConfig.url;
        let matchArr = urlStr.match(rex);
        if(matchArr != null){
            let netstarApiId = matchArr[1];
            let rexStr = matchArr[0];
            urlStr = urlStr.replace(rexStr, '');
            ajaxConfig.url = urlStr;
            ajaxConfig.headers['netstar-api-id'] = netstarApiId;
        }
        // 处理url '/netstarApiId{id}'  end --



        delete ajaxConfig.contentType;
        if(typeof(ajaxConfig.headers['netstar-api-log'])=='object'){
            ajaxConfig.headers['netstar-api-log'] = JSON.stringify(ajaxConfig.headers['netstar-api-log']);
        }
        if(ajaxConfig.headers['netstar-api-log']){
            ajaxConfig.headers['netstar-api-log'] = window.NetStarUtils.base64Safe.encode(ajaxConfig.headers['netstar-api-log']);
        }//sjj 20220211 操作日志中文转码
    }
    /**
     * @param  {any} ajaxConfig
     * @param  {Function} successFunc
     */
    export function ajax(ajaxConfig:any,callBackFunc:Function,failBackFunc:Function){
        let sendAjaxConfig = window.NSUtils.deepCopy(ajaxConfig);
        if(ajaxConfig.data instanceof FormData){
            sendAjaxConfig.data = ajaxConfig.data;
        }
        let isAjax = setAjaxConfig(sendAjaxConfig,callBackFunc,failBackFunc);
        //ajax前置时返回false 不执行接口
        if(isAjax === false){
            return false
        }
        //在setAjaxConfig中处理了FormData数据
        // if(ajaxConfig.contentType === 'multipart/form-data'){
        //     sendAjaxConfig.data = ajaxConfig.data;
        // }
        // 验证ajax.data 配置是否完整 lyw 2022/10/27  start---------------
        if(sendAjaxConfig.validAjaxDataRequired){
            let ajaxDataIsSuccess = validAjaxDataRequired(sendAjaxConfig);
            if(!ajaxDataIsSuccess){
                console.warn("发送ajax失败，请检查发送参数是否完整", sendAjaxConfig);
                setTimeout(function(){
                    callBackFunc({
                        success : true,
                        data : {},
                        rows : [],
                    }, sendAjaxConfig);
                }, 100)
                return;
            }
        }
        // 验证ajax.data 配置是否完整 lyw 2022/10/27  end---------------
        window.axios(sendAjaxConfig).then(function(response:any) {
            let resData = typeof(response.data)=='object' ? response.data :{};
            if(response.status >= 200 && response.status < 300){
                if(response.headers['content-type'] === 'text/html'  || response.headers['content-type'] == "text/html; charset=utf-8"){
                    resData = {
                        success:true,
                        dataType:'html',
                        data:response.data
                    };         
                }
                //200代表返回值正常
                if(typeof(response.config.proxy.ajaxAfterHandler)=='string'){
                    let ajaxAfterHandler = window.NSUtils.getFunction(response.config.proxy.ajaxAfterHandler);
                    if(typeof(ajaxAfterHandler) == "function"){
                        let _data = ajaxAfterHandler(response.data,response.config);
                        if(_data){
                            resData = _data;
                        }
                    }
                }
                let plusObj:any = {};
                if(response.config){
                    if(typeof(response.config.proxy)=='object'){
                        if(typeof(response.config.proxy.plusData)=='object'){
                            plusObj = response.config.proxy.plusData;
                        }
                    }
                }
                //let isMultiAjax:boolean = typeof(plusObj.isMultiAjax)=='boolean' ? plusObj.isMultiAjax : false;
                //有logFileName弹出提示点击提示可以查看详情，但比如getByID返回false,看弹出错误也应该有回调才对，不给回调是因为怕弹出提示语重复
                //所以写了个bug,需要修正 logFileName需要是一个可以请求的json，比如1.json
                /*if(resData.logFileName && resData.success === false && (isMultiAjax === false)){
                    //sjj  弹出错误日志
                    if(typeof(plusObj.controllerObj)=='object'){
                        resData['NETSTAR-URL'] = plusObj.controllerObj.url;
                    }
                    window.nsAlert(resData.msg,'error');
                    window.toastr.remove();
                    let nstoastrError =  new window.NSToastr(resData.msg,resData,'error');
                    nstoastrError.timer = 5000;//60000
                    nstoastrError.show();
                    if(typeof(plusObj.removeDisabledFunc)=='function'){
                        plusObj.removeDisabledFunc(plusObj);
                    }
                }*/
                if(typeof(response.config.proxy.callBackFunc)=='function'){
                    let plusDataOptions:any = {plusData:{}};
                    if(typeof(response.config.proxy.plusData)=='object'){
                        plusDataOptions.plusData = response.config.proxy.plusData;
                    }
                    response.config.proxy.callBackFunc(resData,plusDataOptions);
                }else{
                    if(typeof(plusObj.removeDisabledFunc)=='function'){
                        plusObj.removeDisabledFunc(plusObj);
                    }
                }
                if(window.jQuery.isArray(resData.midwareInfos)){
                    if(resData.midwareInfos.length > 0){
                        let pushSessionObj = {
                            url:response.config.proxy.ajaxUrl.split('?')[0],
                            midwareInfos:resData.midwareInfos,
                            logFileName:resData.logFileName,
                        };
                        let storeNSAjaxStr = window.sessionStorage.getItem('NSAJAXCONFIG');
                        if(storeNSAjaxStr){
                            try{
                                let nsajaxArray = JSON.parse(storeNSAjaxStr);
                                if(!window.jQuery.isArray(nsajaxArray)){
                                    nsajaxArray = [];
                                }
                                //如果当前的是已经缓存的值，执行替换操作
                                let isExistPushAjaxI = -1;
                                for(let ajaxSessionI=0; ajaxSessionI<nsajaxArray.length; ajaxSessionI++){
                                    if(nsajaxArray[ajaxSessionI].url === pushSessionObj.url){
                                        isExistPushAjaxI = ajaxSessionI;
                                        break;
                                    }
                                }
                                if(isExistPushAjaxI > -1){
                                    nsajaxArray.splice(isExistPushAjaxI,1,pushSessionObj);//替换
                                }else{
                                    if(nsajaxArray.length < 10){
                                        nsajaxArray.unshift(pushSessionObj);//不满10个可以继续追加
                                    }else if(nsajaxArray.length === 10){
                                        nsajaxArray.splice(0,1);//当前缓存已经存储10个
                                        nsajaxArray.unshift(pushSessionObj);//不满10个可以继续追加
                                    }
                                }
                                window.sessionStorage.setItem('NSAJAXCONFIG',JSON.stringify(nsajaxArray));
                            }catch(errorStoreAJAX){
                                
                            }
                        }else{
                            let nsajaxArray = [];
                            nsajaxArray.unshift(pushSessionObj);//不满10个可以继续追加
                            window.sessionStorage.setItem('NSAJAXCONFIG',JSON.stringify(nsajaxArray));
                        }
                    }
                }
            }else{
                console.warn(response);
            }
        }).catch(function (error:any) {
            console.error(error);
            let resData:any = {};

            if(error.response && error.response.status === 501 && resData.success === false){
                //501返回
                if(typeof(error.response.config.proxy.callBackFunc)=='function'){
                    let plusDataOptions:any = {plusData:{}};
                    if(typeof( error.response.config.proxy.plusData)=='object'){
                        plusDataOptions.plusData = error.response.config.proxy.plusData;
                    }
                    resData.success = true;
                    resData.status = error.response.status;
                    error.response.config.proxy.callBackFunc(resData,plusDataOptions);
                }
                return;
            }else if(error.response && error.response.status == 403){
                //403错误 延迟30秒触发
                let plusDataObj:any = {};
                let proxyObj:any = {}; 
                if(error.config && error.config.proxy){
                    proxyObj = error.config.proxy;
                }
                plusDataObj = typeof(proxyObj.plusData)=='object' ? proxyObj.plusData : {};
                if(plusDataObj.disabledDomId){
                    let $curBtn = window.jQuery('#'+plusDataObj.disabledDomId);
                    $curBtn.addClass('pt-timer-interval');
                    let tempTimerInter:any;
                    let originalSpanHtml = $curBtn.children('span').html();
                    let updateInterval:Function = function(){
                        let timerIntervalSecond = 30;//30秒
                        tempTimerInter = setInterval(function(){
                            timerIntervalSecond--;
                            let spanHtml = '请等待'+timerIntervalSecond+'秒';
                            $curBtn.children('span').html(spanHtml);
                            if(timerIntervalSecond === 0){
                                clearInterval(tempTimerInter);
                                $curBtn.children('span').html(originalSpanHtml);
                                $curBtn.removeAttr('disabled');
                                $curBtn.removeClass('pt-timer-interval');
                                let errorObj:any = {success:false};
                                if(typeof(proxyObj.failBackFunc)=='function'){
                                    failBackFunc(errorObj,plusDataObj);
                                }
                            }
                        },1000)
                    };
                    updateInterval();
                }else{
                    console.warn(error.config);
                }
                return;
            }
            if(typeof(error.config)=='undefined'){
                return;
            }
            if(error.response && error.response.data){
                resData = error.response.data;
            }
            if(typeof(error.response)=='undefined'){
                window.nsalert('服务器无响应，请检查网络连接情况','error');
                if(typeof(failBackFunc) == 'function'){
                    failBackFunc({success:false},{});
                }
                return;
            }
            if(error.response && typeof(error.response.headers['content-type'])!='string'){
                error.response.headers['content-type'] = '';
            }
            if(error.response && error.response.headers['content-type'].indexOf('text/html')!==-1){
                let htmlStr = window.NSUtils.htmlCode.getTagHtml('h1',error.response.data);
                if(htmlStr === ''){
                    htmlStr = window.language.ajaxErrorMsg.unknown;
                }
                let nsResponseError =  new window.NSToastr(htmlStr,{},'error');
                nsResponseError.show();
                let errorObj:any = {success:false};
                if (typeof (failBackFunc) == 'function') {
                    let tempObj:any = {};
                    if(error.response && error.response.config){
                        if(error.response.config.proxy.plusData){
                            tempObj = error.response.config.proxy.plusData;
                        }
                    }
                    if(error.response && error.response.data){
                        errorObj = error.response.data;
                    }
                    failBackFunc(errorObj,tempObj);
                }
            }else{
                let errorObj:any = {success:false};
                if (typeof (failBackFunc) == 'function') {
                    let tempObj:any = {};
                    if(error.response && error.response.config){
                        if(error.response.config.proxy.plusData){
                            tempObj = error.response.config.proxy.plusData;
                        }
                    }
                    if(error.response && error.response.data){
                        errorObj = error.response.data;
                    }
                    failBackFunc(errorObj,tempObj);
                }else{
                    // console.log(error)
                    window.NSUtils.defaultAjaxError(error, null);
                }
            }
        });
        window.axios.interceptors.response.use(function(response:any){
            // 对响应数据做点什么
            return response;
        }, function (error:any) {
            // 对响应错误做点什么
            let config = error.config;
            if(error.response && error.response.status === 502){
                //如果状态是502第一次502不报错不执行后续方法，需要重新发送ajax请求并且只重新发一次
                config.proxy.retryCount = typeof(config.proxy.retryCount)=='number' ? config.proxy.retryCount : 0;
                if(config.proxy.retryCount === 0){
                    //第一次直接return不执行后续方法并且需要重新发送请求
                    config.proxy.retryCount++;
                    let backOff = new Promise(function(resolve:any){
                        setTimeout(function(){
                            resolve();
                        },500)
                    })
                    return backOff.then(function(){
                        return window.axios(config);
                    })
                }else{
                    return Promise.reject(error);  
                }
            }else{
                //不是502错误按正常流程走
                return Promise.reject(error);
            }
        });
    }
    /**
     * ajax error
     * @param error 
     */
    export function defaultAjaxError(error: any, callBackFunc: Function|null){
        let ajaxErrorInfos = window.NSAJAXERRORINFO.default;
        let isDetail = false;
        let defaultErrorMsg = {};
        if(typeof(window.NetstarApiConfig) == "object"){
            if(window.NSAJAXERRORINFO[window.NetstarApiConfig.errorInfoMode]){
                isDetail = window.NetstarApiConfig.errorInfoMode == "detail";
                ajaxErrorInfos = window.NSAJAXERRORINFO[window.NetstarApiConfig.errorInfoMode];
            }
            if(!window.jQuery.isEmptyObject(window.NetstarApiConfig.defaultErrorMsg)){
                defaultErrorMsg = window.NetstarApiConfig.defaultErrorMsg;
            }
        }
        ajaxErrorInfos = window.NetStarUtils.getI18n(ajaxErrorInfos);
        const i18n = window.NetStarUtils.getI18n(window.NetStarUtils.I18n);
        let errorinfo = typeof (ajaxErrorInfos[error.status]) == "string" ? ajaxErrorInfos[error.status] : ajaxErrorInfos.default;
        if(defaultErrorMsg[error.status]){
            errorinfo = defaultErrorMsg[error.status];
        }
        if(isDetail){
            let msgStr = error.msg;
            if (typeof (msgStr) == 'string') {
                if(msgStr.length > 40){
                    msgStr = msgStr.substring(0, 40);
                }
                errorinfo = window.NetStarUtils.getI18nTipsStr(i18n.ajaxRequestError, { errorMsg: msgStr });
            }else{
                if(error.status){
                    errorinfo = window.NetStarUtils.getI18nTipsStr(i18n.ajaxRequestError2, { errorState: error.status, errorInfo: errorinfo });
                }else{
                    errorinfo = window.NetStarUtils.getI18nTipsStr(i18n.ajaxRequestError3, { errorState: error.status });
                }
            }
        }
        if(typeof(callBackFunc) == "function"){
            callBackFunc(errorinfo);
        }else{
            console.error(errorinfo);
            let nsResponseError =  new window.NSToastr(errorinfo, {}, 'error');
            nsResponseError.show();
        }
    }

    export function logAjax(ajaxData?:any){
        if(typeof(window.NSSystemConfig)=='object'){
            if(typeof(window.NSSystemConfig.logs)=='object'){
                let ajaxConfig:any = typeof(window.NSSystemConfig.logs.ajax) === 'object' ? window.NSSystemConfig.logs.ajax : {};
                if(!window.jQuery.isEmptyObject(ajaxConfig)){
                    if(typeof(window.NSSystemConfig.logs.expression)=='object'){
                        if(window.NSSystemConfig.logs.expression.exportXls){
                            ajaxConfig.headers = typeof(ajaxConfig.headers)=='object' ? ajaxConfig.headers : {};
                            ajaxConfig.headers['netstar-api-log'] = {content:window.NSUtils.htmlCode.getRegularHtml(ajaxData,window.NSSystemConfig.logs.expression.exportXls)};//配置了操作日志 
                        }
                    }
                    window.NSUtils.ajax(ajaxConfig,function(res:any){
                        res = typeof(res)=='object' ? res : {};
                        let msgStr:string = res.msg ? res.msg : '';
                        console.warn(msgStr);
                    },function(errorRes:any){
                        errorRes = typeof(errorRes)=='object' ? errorRes : {};
                        let msgStr:string = errorRes.msg ? errorRes.msg : '';
                        console.warn(msgStr);
                    })
                }
            }
        }
    }//操作日志ajax

    function validAjaxDataRequired(ajaxConfig){
        let ajaxDataIsSuccess = true;
        if(ajaxConfig.validAjaxDataRequired){
            switch(ajaxConfig.validAjaxDataRequired){
                case "emptyObject":
                    if(ajaxConfig.data == "{}" || (typeof(ajaxConfig.data) == "object" && window.$.isEmptyObject(ajaxConfig.data))){
                        ajaxDataIsSuccess = false;
                    }
                    break;
                case "emptyString":
                    if(ajaxConfig.data === ""){
                        ajaxDataIsSuccess = false;
                    }
                    break;
                default:
                    let validAjaxDataRequiredFields = ajaxConfig.validAjaxDataRequired.split(",");
                    let validAjaxDataRequiredFieldObj = {};
                    for(let vI=0; vI<validAjaxDataRequiredFields.length; vI++){
                        validAjaxDataRequiredFieldObj[validAjaxDataRequiredFields[vI]] = '{' + validAjaxDataRequiredFields[vI] + '}';
                    }
                    if(window.$.isEmptyObject(validAjaxDataRequiredFieldObj)){
                        break;
                    }
                    let sendAjaxData = ajaxConfig.data;
                    if(typeof(sendAjaxData) == "string"){
                        try {
                            sendAjaxData = JSON.parse(sendAjaxData);
                        } catch (error) {
                            console.error("ajaxData验证失败原因：", error);
                        }
                    }
                    if(typeof(sendAjaxData) != "object"){
                        ajaxDataIsSuccess = false;
                        break;
                    }
                    let validAjaxDataRequiredFieldData = window.NetStarUtils.getFormatParameterJSON(validAjaxDataRequiredFieldObj, sendAjaxData);
                    for(let key in validAjaxDataRequiredFieldData){
                        if(validAjaxDataRequiredFieldData[key] === null){
                            ajaxDataIsSuccess = false;
                            break;
                        }
                    }
                    break;
            }
        }
        return ajaxDataIsSuccess;
    }
}
export default ajaxManager;